const boundary = document.querySelector('meta[name="cart_free_boundary"]');
const product = {};
product.freeShippingBoundary = boundary ? Number(boundary.content) : 300000;
product.shippingPrepareUrl = '/cart/prepare_shipping_rates.json?shipping_address%5Bzip%5D=1000000&shipping_address%5Bcountry%5D=Japan&shipping_address%5Bprovince%5D=Tokyo';
product.shippingAsyncUrl = '/cart/async_shipping_rates.json';
product.isRecommendInit = false;
product.getItem = function(item, i) {
  const div = document.createElement('div');
  div.className = 'l-cart__item';
  let _p = item.presentment_price * item.quantity;
  _p = _p.toLocaleString();
  div.innerHTML = `
    <div class="l-cart__item-inner">
      <figure class="l-cart__item-photo"><img src="${item.image ?? 'https://cdn.shopify.com/shopifycloud/shopify/assets/no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c_720x.gif'}" alt=""></figure>
      <div class="l-cart__item-detail">
        <p class="l-cart__item-ttl">${item.product_title}</p>
        <p class="l-cart__item-price">¥${ _p }<small>(税込)</small></p>
        <div class="l-cart__amount">
          <div class="l-cart__amount-inner">
            <div class="l-cart__amount-minus js-cart-update" data-line="${i}" data-to="${item.quantity - 1}"></div>
            <div class="l-cart__amount-curr">${item.quantity}</div>
            <div class="l-cart__amount-plus js-cart-update" data-line="${i}" data-to="${item.quantity + 1}"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="l-cart__item-delete">
      <button class="js-cart-item-delete" data-line="${i}">削除する</button>
    </div>
  `;

  return div;
};
product.refreshCart = function(cart) {
  if (typeof loadingContents !== "undefined") {
    $(window).trigger('loadCartShow');
  }

  const refresh = function(res) {
    $('.js-cart-btn > .c-btn__cart > span:last-child').each(function(i, e) {
      e.innerText = res.item_count;
    });

    $('[data-product-id]').each(function(i, e) {
      e.classList.remove('is-current');
    });
    let includeMessageTag = false;
    const message = document.querySelector('.js-shipping-memo');
    const el = document.querySelector('.js-cart-items');
    el.innerHTML = '';
    for (let i in res.items) {
      $('[data-product-id="' + res.items[i].variant_id + '"]').each(function(i, e) {
        e.classList.add('is-current');
      });
      el.appendChild(product.getItem(res.items[i], Number(i) + 1));
      $.get('/products/' + res.items[i].handle + '.json').done(res => {
        if (typeof res.product === 'undefined' || !message) {
          return;
        }

        if (res.product.tags.split(', ').includes('メッセージ')) {
          message.style.display = '';
          includeMessageTag = true;
        }
      });
    }
    if (!includeMessageTag) {
      message.style.display = 'none';
      message.querySelector('textarea').value = '';
    }

    product.fetchShippingRates(function() {
      product.calculatorPrice(res);
    });
    product.hookDeleteCart();
    product.hookUpdateCart();

    if (typeof loadingContents !== "undefined") {
      $(window).trigger('loadCartHide');
    }
  };

  if (typeof cart !== 'undefined') {
    refresh(cart);
  } else {
    $.get('/cart.json').done(function(res) {
      refresh(res);
    });
  }
};
product.calculatorPrice = function(cart) {
  if (cart.item_count > 0) {
    const shippingCost = window.ShippingRates.length ? window.ShippingRates[0].price * 100 : 0;
    const result = $.get('/cart.json');
    result.done(function(res) {
      let _st = 0;
      _st = res.total_price * 0.01;
      _st = _st.toLocaleString();
      document.querySelector('.js-cart-subtotal').innerHTML =
        '\xA5' + _st + '<small>(税込)</small>';
      _t = (res.total_price + shippingCost) * 0.01;
      _t = _t.toLocaleString();
      document.querySelector('.js-cart-total').innerHTML =
        '\xA5' + _t + '<small>(税込)</small>';
      document.querySelector('.js-cart-shipping').innerHTML =
        shippingCost > 0 ? Shopify.formatMoney(shippingCost) + '<small>(税込)</small>' : '<strong>無料</strong>';
      const remainingPrice = product.freeShippingBoundary - res.total_price;
      const balloon = document.querySelector('.js-cart-balloon');
      if (balloon) {
        if (remainingPrice > 0) {
          balloon.innerText = `あと${Shopify.formatMoney(remainingPrice)}（税込）のご購入で送料無料`;
          balloon.style.display = '';
        } else {
          balloon.style.display = 'none';
        }
      }
    });

    document.querySelector('.js-cart-items').style.display = '';
    document.querySelector('.js-cart-inner').style.display = '';
    document.querySelector('.js-cart-blank').style.display = 'none';
  } else {
    document.querySelector('.js-cart-items').style.display = 'none';
    document.querySelector('.js-cart-inner').style.display = 'none';
    document.querySelector('.js-cart-blank').style.display = '';
  }
};
product.prepareShippingRates = function(callback) {
  $.post(product.shippingPrepareUrl).done(function() {
    if (typeof callback === "function") {
      callback();
    }
  });
};
product.fetchShippingRates = function(callback) {
  const func = function() {
    const result = $.get(product.shippingAsyncUrl);
    result.done(function(resp, status, xhr) {
      if (xhr.status !== 200 || !resp) {
        func();
      } else {
        window.ShippingRates = resp.shipping_rates;
      }
    });
    result.always(function() {
      if (typeof callback === "function") {
        callback();
      }
    });
  }

  if (typeof window.ShippingRates !== 'undefined') {
    func();
  } else {
    product.prepareShippingRates(function() {
      func();
    });
  }
};
product.addCart = function(data) {
  return $.ajax({ url: '/cart/add.js', type: 'post', dataType: 'json', data: data });
};
product.updateCart = function(line, q, id) {
  const data = {};
  if (id) {
    data['id'] = id;
  } else {
    data['line'] = line;
  }
  data['quantity'] = q;

  return $.ajax({ url: '/cart/change.js', type: 'post', dataType: 'json', data: data });
};
product.hookAddCart = function() {
  $('.js-product-submit').on('click', function(event) {
    event.preventDefault();

    const result = product.addCart($('.js-product').serialize());
    result.done(function() {
      $('.js-cart-btn').trigger('click');
      product.refreshCart();
    });
    result.fail(function(res) {
      alert(res.responseJSON.description);
    });
  });
};
product.hookDeleteCart = function() {
  $('.js-cart-item-delete').off('click');
  $('.js-cart-item-delete').on('click', function() {
    product.updateCart(this.dataset.line, 0).done(function(res) {
      product.refreshCart(res);
    });
  });
};
product.hookUpdateCart = function() {
  $('.js-cart-update').off('click');
  $('.js-cart-update').on('click', function() {
    product.updateCart(this.dataset.line, this.dataset.to).done(function(res) {
      product.refreshCart(res);
    });
  });
};
product.hookSubmitCart = function() {
  $('.js-cart-submit').on('click', function(event) {
    event.preventDefault();

    const path = event.target.href;
    const data = {
      'attributes': {
        'haisoyamatoshippingdate': document.querySelector('[name="attributes[haisoyamatoshippingdate]"]').value,
        'haisoyamatoshippingtime': document.querySelector('[name="attributes[haisoyamatoshippingtime]"]').value,
      },
      'note': document.querySelector('[name="note"]').value,
    };

    const res = $.ajax({ url: '/cart/update.js', type: 'post', dataType: 'json', data: data });
    res.done(function() {
      location.href = path ? path : '/checkout';
    });
  });
};
product.updateAmount = function(rate) {
  const el = document.querySelector('.js-amount-current');
  const amount = parseInt(el.textContent) + rate;

  if (amount > 0) {
    el.innerText = amount;
    document.querySelector('input[name="quantity"]').value = amount;
  }
};
product.hookUpdateAmount = function() {
  $('.js-amount-plus').on('click', function() {
    product.updateAmount(1);
  });

  $('.js-amount-minus').on('click', function() {
    product.updateAmount(-1);
  });
};
product.hookCartBtn = function() {
  $('a[data-product-id]').off('click');
  $('a[data-product-id]').on('click', function(event) {
    event.preventDefault();
    const target = event.currentTarget;
    const fail = function(res) {
      alert(res.responseJSON.description);
    };

    if (!target.dataset.toggle || !target.classList.contains('is-current')) {
      product.addCart('id=' + target.dataset.productId + '&quantity=1').done(function() {
        if (!$('.js-cart.is-open').length) {
          $('.js-cart-btn').trigger('click');
        }
        product.refreshCart();
      }).fail(function(res) {
        fail(res);
      });
    } else {
      product.updateCart(null, 0, target.dataset.productId).done(function(res) {
        product.refreshCart(res);
      }).fail(function(res) {
        fail(res);
      });
    }
  });
};
product.watchItemLists = function() {
  $('.p-products__item-list').each(function(i, target) {
    (new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        product.hookCartBtn();
      });
    })).observe(target, {
      childList: true,
      subtree: true
    });
  });
};
product.watchBuyButton = function() {
  let triggeredHandlerCount = 0;
  const observer = new MutationObserver(function(mutations) {
    const btn = document.querySelector('[data-shopify="payment-button"] [data-testid="Checkout-button"]');
    if (btn) {
      observer.disconnect();
      btn.innerHTML = '<span>予約する</span>';
      if (++triggeredHandlerCount <= 100) {
        observe(btn);
      }
    }
  });
  const observe = function(btn) {
    observer.observe(btn, {
      childList: true,
      subtree: true
    });
  }

  const outerBtn = document.querySelector('[data-shopify="payment-button"]');
  if (outerBtn) {
    observe(outerBtn);
  }
};
product.updateProductVariantId = function() {
  const id = document.querySelector('input[name="id"]');
  const variant = document.querySelector('.js-variant');
  variant.addEventListener('change', function() {
    id.value = variant.value;
  });
};
product.init = function() {
  product.hookAddCart();
  product.hookDeleteCart();
  product.hookUpdateCart();
  product.hookUpdateAmount();
  product.hookSubmitCart();
  product.hookCartBtn();
  product.watchItemLists();
  product.watchBuyButton();
  product.fetchShippingRates(function() {
    product.refreshCart();
  });
  product.updateProductVariantId();
};

(function() {
  product.init();
})();
